// extracted by mini-css-extract-plugin
export default {"list":"list_list","selected":"list_selected","flag":"list_flag","code":"list_code","name":"list_name","check":"list_check"};